import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { LoggingService } from "src/app/core";
import { NewFeature } from "src/app/core/models/new-feature";
import { NewFeatureService } from "src/app/core/services/new-feature.service";
import { HeaderService } from "src/app/layout/services/header.service";

const Workflow: string = "NewFeatures";
const WorkflowSource: string = "NewFeatureCarousel";

@Component({
  selector: "app-new-feature-carousel",
  standalone: false,
  templateUrl: "./new-feature-carousel.component.html",
  styleUrl: "./new-feature-carousel.component.scss",
})
export class NewFeatureCarouselComponent implements OnInit, OnDestroy {
  newFeatures: NewFeature[];
  private _destroyed$: Subject<void> = new Subject<void>();

  constructor(
    private _loggingService: LoggingService,
    private _headerService: HeaderService,
    private _newFeatureService: NewFeatureService,
  ) {}

  ngOnInit(): void {
    this._newFeatureService.newFeaturesCarousel$.pipe(takeUntil(this._destroyed$)).subscribe((newFeatures: NewFeature[]) => {
      this.newFeatures = newFeatures;
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  onNewFeatureClick(newFeature: NewFeature): void {
    this._newFeatureService.openNewFeatureDialog(newFeature.featureId, WorkflowSource);
  }

  onHideClick(): void {
    this._headerService.toggleHeaderDrawer();
    this._loggingService.logWorkflow(
      "New Feature Carousel Hidden",
      "NewFeatureCarouselComponent.onHideClick",
      Workflow,
      "CarouselHideClick",
      WorkflowSource,
    );
  }

  onCarouselInteract(): void {
    this._loggingService.logWorkflow(
      "New Feature Carousel Interaction",
      "NewFeatureCarouselComponent.onCarouselInteract",
      Workflow,
      "CarouselInteraction",
      WorkflowSource,
    );
  }
}
